export let UserData = {
    token: '',
    roles: [],
    subRoles: [],
    rolez: {},
    singleOrgApp: false,
    organizationId: '',
    currentOrganization: {
        id: ''
    },
    appName: '',
    practiceSetData: {},
    altitudeZeroDisplay: '',
    altitudeRangeDisplayDivision: false,
    backend_url: '',
    basic_vectoring_webgl_url: '',
    advanced_vectoring_webgl_url: '',
    email_service_base_url: '',
    email_service_app_id: '',
    keycloak_url: '',
    keycloak_realm: '',
    keycloak_client: '',
    applications: '',
    app_libraries: '',
    gameAppName: '',
    gameAppId: '',
    isRouting: false,
    // start SG-5501
    userId: '',
    iVySessionId: '',
    ivy_chat_url: '',
    ivy_feedback_url: '',
    stratagem_feedback_app_id: '',
    mobileUserData: null as any
    // end SG-5501
};
